import React from 'react'

const MobileDatePickerControlBar = ({
  mobileLmpDate,
  selectText,
  clearText,
  onClear,
}) => {
  const buttonClass = mobileLmpDate ? '' : 'disabled'
  const labelText = mobileLmpDate
    ? mobileLmpDate.toLocaleDateString()
    : selectText

  return (
    <div className="MobileDatePickerControlBar">
      <h3>{labelText}</h3>
      <button
        type="button"
        className={`clear ${buttonClass}`}
        onClick={onClear}
        disabled={!(buttonClass === '')}
      >
        {clearText}
      </button>
    </div>
  )
}

export default MobileDatePickerControlBar
